import { API } from 'data/30pay.api';
import { LevelOne } from 'interfaces';
import { Dispatch, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import { post } from 'scripts';

export const requestUpgradeTo1 = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { nationalCode?: string; cardNumber?: string; birthDate?: string },
    setData: Dispatch<SetStateAction<LevelOne | undefined>>,
    onComplete?: (e: LevelOne) => void,
) => {
    setLoading(true);
    await post<LevelOne>(API.level.requestUpgradeTo1, data)
        .then((response) => {
            setData(response.value.value);
            onComplete && onComplete(response.value.value);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
};

export const verifyUpgradeTo1 = async (data: { isConfirmed: boolean }) => {
    return new Promise((resolve, reject) => {
        post(API.level.verifyUpgradeTo1, data)
            .then((response) => {
                toast.success(response.value.message);
                resolve(response.value.value);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
